import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {TtmImage} from '../classes/ttmimage';

@Injectable({
    providedIn: 'root'
})
export class TtmImageService {

    constructor(private apiService: ApiService) {
    }

    getTtmImages(ttmId: number) {
        return this.apiService.getCall$<TtmImage[]>(`ttm-images/${ttmId}`);
    }

    latestImage() {
        return this.apiService.getCall$<TtmImage>(`ttm-images/latest`);
    }

    useLatest(ttm_status_key: string, latest_image_id: number, ttm_id: number, position?: { lat: number; lng: number }) {
        const data = {ttm_status_key, latest_image_id, ttm_id, position};
        return this.apiService.postCall$<TtmImage>(`ttm-images/latest`, data);
    }

    uploadImage(file: File, ttm_status_key: string, ttm_id: number, position?: { lat: number; lng: number }, heading?: number) {
        let data = {};
        data = {ttm_status_key, ttm_id};
        if(position) {
            data = { ...data, position};
        }
        if (heading !== undefined && heading !== null) {
            data = {...data, heading};
        }
        return this.apiService.makeFileRequest$<TtmImage>('ttm-images/upload', file, data);
    }

    deleteImage(ttmImageId: number) {
        return this.apiService.deleteCall$<TtmImage>(`ttm-images/${ttmImageId}`);
    }
}
